<template>
  <div v-if="test">
    <div class="clearfix mb-3 underline">
      <div class="page-title float-left "><mdb-icon icon="chalkboard-teacher" /> {{test.name}}
        <small class="ml-3">
          {{$route.query.seq}}차 수행 평가 파일 업로드
        </small>
      </div>
    </div>
    <check-password v-if="mode === 'CHECKTEST'" @success-password="mode='TEST'"/>
    <div v-if="mode === 'TEST'" class="mt-5">
      <mdb-row>
        <mdb-col md="2" class="text-right title">파일선택</mdb-col>
        <mdb-col md="10">
          <input type="file" ref='performFile' @change="selectFile">
          <div ><mdb-btn icon="check" class="mt-5" @click="onSave" :disabled="!this.performFile">제출하기</mdb-btn></div>
        </mdb-col>
      </mdb-row>
    </div>
    <div v-if="this.test">
      <div class="sub-title my-3">
        [수행 평가 문제]
        <span style="font-size:14px">문제가 보이지 않는 경우 새로고침(F5) 해주세요</span>
      </div>
      <div class="sub-title my-3">문제</div>
      <pre v-if="$route.query.seq==1 && this.test.task1">{{this.test.task1.testQuestion}}</pre>
      <pre v-if="$route.query.seq==2 && this.test.task2">{this.test.task2.testQuestion}}</pre>
      <div class="sub-title my-3">평가기준</div>
      <pre v-if="$route.query.seq==1 && this.test.task1">{{this.test.task1.testGuide}}</pre>
      <pre v-if="$route.query.seq==2 && this.test.task2">{{this.test.task2.testGuide}}</pre>
    </div>

    <!-- <folder-label label="수행평가 문제보기" class="my-3">
      <div class="sub-title my-3">문제{{$route.query.seq}}</div>
      <pre>{{getTestQuestion($route.query.seq)}}</pre>
      <div class="sub-title my-3">평가기준</div>
      <pre>{{getTestGuide($route.query.seq)}}</pre>
    </folder-label> -->
  </div>
</template>
<script>
import { mdbTbl, mdbTblBody, mdbTblHead } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PerformTestAnswer from '@/models/test/PerformTestAnswer'
import CheckPassword from '@/components/test/CheckPassword.vue';
import FolderLabel from '@/components/common/FolderLabel.vue';
export default {
  components: {
    CheckPassword
    // FolderLabel
  },
  name: 'StudentSelfTestExam',
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    ...mapGetters('training', ['teacher'])
  },
  data: () => ({
    mode: 'CHECKTEST',
    performFile: undefined,
    test: {},
    answer: {}
  }),
  methods: {
    async onSave () {
      if (!confirm('제출할까요?')) return
      const form = new FormData();
      form.append('training', this.test.training)
      form.append('student', this.profile._id)
      form.append('teacher', this.teacher)
      form.append('name', this.test.name)
      form.append('code', this.test.code)
      form.append('seq', this.$route.query.seq)
      form.append('performFile', this.performFile)
      const res = await PerformTestAnswer.upload(form)
      if (res.result === 'ok') {
        this.$router.back()
      } else {
        alert('업로드에 실패했습니다.')
      }
    },
    selectFile () {
      this.performFile = this.$refs.performFile.files[0]
    }
    // getTestQuestion (seq) {
    //   console.log('getTestQuestion', seq, this.test)
    //   if (!this.test || !this.test.task1) return ''

    //   if (seq === '1' && this.test.task1) {
    //     return this.test.task1.testQuestion
    //   } else if (seq === '2' && this.test.task2) {
    //     return this.test.task2.testQuestion
    //   }
    //   return ''
    // },
    // getTestGuide (seq) {
    //   console.log('getTestGuide', seq, this.test)
    //   if (!this.test || !this.test.task1) return ''
    //   if (seq === '1' && this.test.task1) {
    //     return this.test.task1.testGuide
    //   } else if (seq === '2' && this.test.task2) {
    //     return this.test.task2.testGuide
    //   }
    //   return ''
    // }
  },
  async created () {
    const { test } = this.$route.query
    this.test = await this.$PerformTest.get(test)
  }
}
</script>
